import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const RULES_ACCEPTED_KEY = 'ttb.rulesAccepted';

type AppState = {
  rulesAccepted: boolean;
  isLoading: boolean;
  bootstrapError: string | null;
};

const initialState: AppState = {
  rulesAccepted: localStorage.getItem(RULES_ACCEPTED_KEY) === '1',
  isLoading: false,
  bootstrapError: null,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setBootstrapError(state, action: PayloadAction<string | null>) {
      state.bootstrapError = action.payload;
    },
    setRulesAccepted(state, action: PayloadAction<boolean>) {
      state.rulesAccepted = action.payload;
      localStorage.setItem(RULES_ACCEPTED_KEY, action.payload ? '1' : '0');
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    resetAppState(state) {
      // Keep rulesAccepted (persisted in localStorage), reset other fields
      state.isLoading = false;
      state.bootstrapError = null;
    },
  },
});

export const appReducer = appSlice.reducer;
export const appActions = appSlice.actions;
